import { CrudList } from '../shared/CrudPage';
import { stockMovementService, enumLabel } from '@kss/api';
import type { StockMovement, StockMovementCreate, StockMovementFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllStockMovements() {
  return (
    <CrudList<StockMovement, StockMovementCreate, StockMovementFilter>
      title="All stock movements" newLabel="New movement" service={stockMovementService}
      idKey="stockMovementId" labelKey="reference" basePath="/panel/stock-movements"
      // Newest movement on top — audit trail is chronological, admins
      // want the just-posted row visible. Ref: ORDER_WORKFLOW_AUDIT #6.
      initialSortStatus={{ columnAccessor: 'movementDate', direction: 'desc' }}
      columns={[
        // Live API field is `movementDate` (not `movedAt`); the
        // legacy accessor always rendered '—'. Reference is now
        // composed from `referenceType` + `notes` since there's no
        // single `reference` column on the live row.
        {
          accessor: 'movementDate',
          title: 'Date',
          sortable: true,
          render: (r) => {
            const d = (r as StockMovement & { movementDate?: string; movedAt?: string }).movementDate
              ?? (r as StockMovement & { movedAt?: string }).movedAt;
            return d ? new Date(d).toLocaleDateString() : '—';
          },
        },
        { accessor: 'movementType', title: 'Type', sortable: true, filterable: true,
          render: (r) => <StatusBadge status={enumLabel('StockMovementType', typeof r.movementType === 'number' ? r.movementType : Number(r.movementType))} /> },
        { accessor: 'productId', title: 'Product', render: (r) => <NameCell kind="product" id={r.productId} /> },
        { accessor: 'warehouseId', title: 'Warehouse', render: (r) => <NameCell kind="warehouse" id={r.warehouseId} /> },
        { accessor: 'quantity', title: 'Qty', sortable: true, textAlign: 'right', render: (r) => Number(r.quantity ?? 0).toLocaleString('en-IN') },
        {
          accessor: 'referenceType',
          title: 'Reference',
          render: (r) => {
            const r2 = r as StockMovement & { referenceType?: string; notes?: string; reference?: string };
            return r2.referenceType || r2.notes || r2.reference || '—';
          },
        },
      ]}
    />
  );
}
